<template>
  <div class="container">
    <div class="columns">
      <div class="column">
        <h2 class="h2Title">Cantáctenos</h2>
        <div class="columns">
          <div class="column is-one-third">
            <div class="imgNotaria">
              <img src="@/assets/notariaVilca.jpg" />
            </div>
            <b-button
              class=""
              type="is-primary is-light"
              @click="$router.push('tramites')"
              expanded
            >
              Crear Cita Virtual
            </b-button>
          </div>

          <div
            itemscope
            itemtype="http://schema.org/Organization"
            class="column"
          >
            <span class="dataHome">
              <!-- <h4 itemprop="name">Notaria Vilca</h4> -->

              <p
                itemprop="address"
                itemscope
                itemtype="http://schema.org/PostalAddress"
              >
                Dirección:
                <a
                  href="https://www.google.com/maps/d/viewer?mid=1muksqrCoTmm06RYdlCwrpjI40NE"
                >
                  <span itemprop="streetAddress"
                    >Av. Aviación, 2468, segundo piso.</span
                  >
                  <span itemprop="addressLocality">SAN BORJA</span>,
                  <span itemprop="addressRegion">LIMA</span>
                </a>
              </p>
              <p>
                E-mail:
                <a itemprop="email" href="mailto:consultas@notariavilca.org"
                  >consultas@notariavilca.org</a
                >
              </p>
              <p>
                Teléfonos Fijos:
                <a itemprop="telephone" href="tel:475-0045"
                  >(0051-1) 475-0045</a
                >
                <a itemprop="telephone" href="tel:475-2235"
                  >(0051-1) 475-2235</a
                >
              </p>
              <p>
                Escrituras Públicas:
                <a itemprop="telephone" href="tel:+51949607456"
                  >+51 949607456</a
                >
                <a itemprop="telephone" href="tel:+51949614682"
                  >+51 949614682</a
                >
                Legalizaciones:
                <a itemprop="telephone" href="tel:+51949624240"
                  >+51 949624240</a
                >
              </p>
            </span>
          </div>

          <div
            itemscope
            itemtype="http://schema.org/Organization"
            class="column"
          >
            <span class="dataHome">
              <p>
                Transferencias Vehículares:
                <a itemprop="telephone" href="tel:+51949636699"
                  >+51 949636699</a
                >
                Escrituras Públicas:
                <a itemprop="telephone" href="tel:+51949632946"
                  >+51 949632946</a
                >
                Registros Públicos:
                <a itemprop="telephone" href="tel:+51949628305"
                  >+51 949628305</a
                >
                Cartas Notariales:
                <a itemprop="telephone" href="tel:+51951063408"
                  >+51 951063408</a
                >
                Informes:
                <a itemprop="telephone" href="tel:+51949640478"
                  >+51 949640478</a
                >
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      imgHome: "https://notariavilca.org/img/notariaVilca.jpg",
    };
  },
};
</script>
<style lang="scss">
.h2Title {
  border-bottom: 1.5px gray solid;
  padding-top: 20px;
  padding-bottom: 15px;
  margin-bottom: 20px;
  font-size: 1.7em;
}
.imgNotaria {
  width: 90%;
  margin: 0 auto;
}
.imgNotaria img {
  width: 100%;
  height: 300px;
}
.container {
  padding: 5px 25px;
}
.dataHome {
  h4 {
    font-size: 1.8em;
  }
}
.dataHome p > a {
  display: block;
}
a {
  color: #0e26aa;
}
.btn-m {
  background-color: #0e263f;
  color: #9bd7f1;
}
.btn-m:hover {
  color: white;
}
</style>
